import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useHeadcount, TotalsStrip, HeadcountGrid, HeadcountCollarTiles } from '@/components/staffAttendance/HeadcountBoard';
import { fmtTime } from '@/services/staffAttendanceApi';

const Clock = () => {
  const [t, setT] = useState(new Date());
  useEffect(() => { const i = setInterval(() => setT(new Date()), 15000); return () => clearInterval(i); }, []);
  return <span className="font-mono text-3xl" data-testid="headcount-tv-clock">{t.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' })}</span>;
};

/** Full-screen TV board — today's headcount per section, refreshes every 60 s. */
export default function HeadcountTV() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const wt = params.get('worker_type');
  const collar = params.get('collar');
  const { data } = useHeadcount({ ...(wt ? { worker_type: wt } : {}), ...(collar ? { collar } : {}) });
  return (
    <div className="min-h-screen bg-slate-900 text-white px-6 py-5 space-y-5" data-testid="headcount-tv">
      <header className="flex items-center gap-4">
        <button type="button" onClick={() => navigate('/attendance?tab=headcount')} className="text-slate-400 hover:text-white" data-testid="headcount-tv-back"><ArrowLeft className="w-6 h-6" /></button>
        <div>
          <div className="text-xs uppercase tracking-widest text-amber-400">Staff Attendance</div>
          <h1 className="text-3xl font-bold">Section Headcount{wt ? ` · ${wt === 'regular' ? 'Regular' : 'Contract'}` : ''}{collar ? ` · ${{ white: 'White Collar', blue: 'Blue Collar', none: 'Collar not set' }[collar] || ''}` : ''}</h1>
        </div>
        <div className="ml-auto text-right">
          <Clock />
          {data && <div className="text-base text-slate-300" data-testid="headcount-tv-updated">{data.date} · Day {data.shift_day?.start}–{data.shift_day?.end} · Night {data.shift_night?.start}–{data.shift_night?.end} · Red = absent above {data.threshold_pct}% · updated {fmtTime(data.generated_at)}</div>}
        </div>
      </header>
      {!data ? <Loader2 className="w-10 h-10 animate-spin mx-auto text-amber-400 mt-20" /> : (<><TotalsStrip t={data.totals} tv /><HeadcountCollarTiles data={data} collar={collar || ''} tv /><HeadcountGrid data={data} tv /></>)}
    </div>
  );
}
